import {
  normalizeTableSearch,
  serializeTableSearch,
  type TableSearchConfig,
} from "./lib/table-search";
import { validateDateRangeSearch } from "./lib/date-range-search";
export const CALLS_REPORT_TABLE: TableSearchConfig = {
  filterKeys: ["from", "to", "assignedTo", "q", "status"],
  sortFields: ["createdAt"],
  defaultSort: "createdAt",
  defaultSortDir: "desc",
  pageSizes: [25, 50, 100],
  defaultPageSize: 100,
};
export function validateCallsReportSearch(raw: Record<string, unknown>) {
  return {
    ...serializeTableSearch(normalizeTableSearch(raw, CALLS_REPORT_TABLE), CALLS_REPORT_TABLE),
    ...validateDateRangeSearch(raw),
  };
}
